'use client';

import { nFormatter } from '@streetferret/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../tooltip';
import { type ReactNode } from 'react';

export function NumberTooltip({
  value,
  unit = '%',
  children,
}: {
  value?: number | null;
  unit?: string;
  children: ReactNode;
}) {
  if (!value || value < 1000) {
    return children;
  }
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent>
          <p>{`${nFormatter(value, { full: true })} ${unit}`}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
